import { Component, OnInit, Input } from '@angular/core';
import { SimulationData } from '@classes/simulation/simulation-data';
import { Cursor } from '@classes/simulation/cursor';
import { ProjectionRate } from '@classes/simulation/projection-rate';
import { SimulationFlagType } from '@enums/simulation-flag-type.enum';
import { IndiceModeType } from '@enums/indice-mode-type.enum';
import { FormatService } from '@services/format.service';
import { SimulationService } from '@services/simulation.service';
import { SimulationYear } from '@classes/simulation/simulation-year';

@Component({
  selector: 'app-partition-cursors-mjp',
  templateUrl: './partition-cursors-mjp.component.html',
  styleUrls: ['./partition-cursors-mjp.component.scss']
})
export class PartitionCursorsMjpComponent implements OnInit {
    @Input() simulation: SimulationData;
    @Input() cursor: Cursor;
    @Input() projectionRate: ProjectionRate;

    FlagType = SimulationFlagType;
    IndiceModeType = IndiceModeType;

    constructor(
        private formatSrv: FormatService,
        private simulationSrv: SimulationService
    ) { }

    ngOnInit() {
    }

    applyValue(value: number, year: SimulationYear, isAmountMode: boolean): void {
        if(value != null) {
            let currentValue: number;

            if(isAmountMode) {
                currentValue = year.amount;
                year.amount = this.formatSrv.precision(value, 2);
            } else {
                currentValue = year.indice;
                year.indice = this.formatSrv.precision(value, 4);
            }

            if (currentValue !== value) {
                year.isRateNeutralized = true;
                year.isAmountEdited = true;
                year.indice = 0;
                year.flag = SimulationFlagType.modified;
                this.simulationSrv.simulationValChanged.next(this.simulation);
            }
        }
    }
}
